export const environment = {
    production: false,
    url: 'https://api.sandbox-taqe.com/v2'
};
